
import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

import {KeyValueItem} from "framework/ui/shared/key-value-item";

@Component({
    selector: "cs-key-value-list-tooltip",
    templateUrl: "./tooltip.component.html",
    styleUrls: [
        "./tooltip.component.scss",
        "../tooltip.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class KeyValueListTooltipComponent
{
    @Input() list: KeyValueItem[];
}
